import React from 'react'
import PropTypes from 'prop-types'

import NewsCard from './NewsCard'

import * as S from './styled'

const ListingNews = ({ posts }) => (
  <S.List>
    {posts &&
      posts.map(post => {
        let categories = false
        if (post.node.data.categories[0].category) {
          categories = post.node.data.categories.map(c => c.category.document[0].data.name)
        }
        return <NewsCard key={post.node.uid} node={post.node} categories={categories} />
      })}
  </S.List>
)

export default ListingNews

ListingNews.propTypes = {
  posts: PropTypes.array.isRequired,
}
